import React from 'react';
import { Alert } from 'react-bootstrap';
import { Information } from 'iconsax-react';

/* Avviso mostrato alle strutture che non hanno ancora confermato i dati di fatturazione (un solo testo per tutte le pagine). */
export const AvvisoFatturazione = () => (
    <Alert variant="warning" className="d-flex align-items-start gap-2 text-dark" style={{ marginBottom: '1rem' }}>
        <Information size="20" className="mt-1 flex-shrink-0" />
        <div>
            Per vendere abbonamenti, corsi, lezioni e prenotazione impianti con l'ecosistema SportId è necessario configurare i dati di
            fatturazione in <strong>La mia struttura → Documenti fiscali</strong>. Puoi creare prodotti e salvarli come bozza.
        </div>
    </Alert>
);

export default AvvisoFatturazione;
